import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';
import PropTypes from 'prop-types';

const BUBBLE_WIDTH = 260;

/**
 * Floating bubble shown over a PDF text selection, offering to quote the
 * selection into the chat composer (ask about it, or request a change).
 */
export function SelectionBubble({ selection, onVerb }) {
  const { t } = useTranslation();
  if (!selection?.rect) return null;

  const { rect } = selection;
  const top = Math.max(8, rect.top - 46);
  const left = Math.min(
    Math.max(8, rect.left + rect.width / 2 - BUBBLE_WIDTH / 2),
    window.innerWidth - BUBBLE_WIDTH - 8
  );

  return (
    <div
      className="fixed z-50 flex items-center gap-1 rounded-lg border border-[var(--color-border)] bg-[var(--color-bg)] p-1 shadow-lg"
      style={{ top, left, width: BUBBLE_WIDTH }}
      // Keep the DOM selection alive when clicking a verb.
      onMouseDown={(e) => e.preventDefault()}
    >
      <button
        type="button"
        onClick={() => onVerb('ask')}
        className="flex items-center gap-1 rounded-md px-2 py-1 text-xs font-medium text-[var(--color-text-secondary)] hover:bg-[var(--color-bg-muted)] cursor-pointer"
      >
        <Icon icon="mdi:message-text-outline" className="size-4" />
        {t('workspace.selectionBubble.ask')}
      </button>
      <div className="h-4 w-px bg-[var(--color-border)]" />
      <button
        type="button"
        onClick={() => onVerb('change')}
        className="flex items-center gap-1 rounded-md px-2 py-1 text-xs font-medium text-[var(--color-accent)] hover:bg-[var(--color-accent-subtle)] cursor-pointer"
      >
        <Icon icon="mdi:pencil-outline" className="size-4" />
        {t('workspace.selectionBubble.change')}
      </button>
    </div>
  );
}

SelectionBubble.propTypes = {
  selection: PropTypes.shape({
    text: PropTypes.string,
    page: PropTypes.number,
    rect: PropTypes.object,
  }),
  onVerb: PropTypes.func.isRequired,
};
